import { Component, Show } from 'solid-js';

import { CreateFxWorkspaceDialog } from '../selections/tree/CreateFxWorkspaceDialog';
import { DeleteFxWorkspaceDialog } from '../selections/tree/DeleteFxWorkspaceDialog';
import type { WorkspacesTabDialogsProps } from './WorkspacesTabDialogs.types';

export const WorkspacesTabDialogs: Component<WorkspacesTabDialogsProps> = (
  props
) => (
  <>
    <Show when={props.isCreateDialogOpen}>
      <CreateFxWorkspaceDialog
        show={props.isCreateDialogOpen}
        onClose={props.onCloseCreateDialog}
      />
    </Show>
    <Show when={props.workspacePendingDelete}>
      {(workspace) => (
        <DeleteFxWorkspaceDialog
          workspaceId={workspace().id}
          workspaceName={workspace().name}
          onClose={props.onCloseDeleteDialog}
        />
      )}
    </Show>
  </>
);
